var classes = {
  "circle": "circle__8otSr",
  "completed": "completed__1v-5a",
  "in-progress": "in-progress__XnQBu",
  "not-started": "not-started__rPPBU"
};
export { classes as default };